import { MetaDTO, MetaType } from '@/types/MetaDTO';
import { apiSlice } from '@/services/api/apiSlice';

export const metaApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getMetaData: build.query<MetaDTO, MetaType>({
      query: (type: MetaType) => ({
        url: '/meta/data',
        method: 'GET',
        params: {
          type: type,
        },
      }),
    }),
  }),
});

export const { useGetMetaDataQuery } = metaApiSlice;
